module.exports = "//cdn.mxpnl.com/static/asset-cache/f21287c42476f689d364685a820d0de9/iron/common/assets/images/charts/stacked-line.svg";